/* src/app/components/user/Notes/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  IconButton,
  Input,
  Menu, MenuItem,
  Modal,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { MoreHoriz, NoteAdd } from '@material-ui/icons';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from './styles';
import { loadTexts } from '../../../../config/texts';
const TEXT_KEY = 'components';

class Notes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      dummy: false,
      notes: [],
      anchorEl: null,
      note: null,
      text: '',
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._scrollToBottom = this._scrollToBottom.bind(this);
    this._scroll = null;

    this._onAddNote = this._onAddNote.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onClickRemove = this._onClickRemove.bind(this);
    this._onOpenMenu = this._onOpenMenu.bind(this);

    this._onChangeText = this._onChangeText.bind(this);
  }

  // TODO: sort data in selector
  componentDidMount() {
    this._scrollToBottom();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open, notes: nextProps.notes }, () => {
      if (!this._scroll) this.setState({ dummy: !this.state.dummy });
    });
  }

  componentWillUpdate() {
    // if (this._scroll) {
    //   const { scrollTop, scrollHeight, clientHeight } = this._scroll;
    //   const scrollBottom = scrollHeight - clientHeight;
    //   this._scrollAtBottom = (scrollBottom <= 0) || (scrollTop === scrollBottom);
    // }
  }

  componentDidUpdate() {
    // if (!this._scroll) this.setState({ dummy: !this.state.dummy });
    this._scrollToBottom();
  }

  _scrollToBottom() {
    if (this._scroll) {
      const { scrollHeight, clientHeight } = this._scroll;
      const maxScrollTop = scrollHeight - clientHeight;
      this._scroll.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
  }

  _onAddNote() {
    const { text } = this.state;
    this.props.onAdd(text);
    this.setState({ text: '' });
  }

  _onOpenMenu(note) {
    return event => { this.setState({ anchorEl: event.currentTarget, note }); };
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null, note: null });
  }

  _onClickRemove() {
    this.props.onRemove(this.state.note);
    this.setState({ note: null, anchorEl: null });
  }

  _onChangeText(event) {
    this.setState({ text: event.target.value });
  }

  render() {
    const { classes, onClose } = this.props;
    const { open, notes, anchorEl, text, texts } = this.state;

    return (
      <Modal open={open} onClose={onClose}>
        <Card className={classes.card}>
          <AppBar position="static" color="primary">
            <Toolbar>
              <Typography variant="title" color="inherit">{texts.notes.title}</Typography>
            </Toolbar>
          </AppBar>
          <Divider />
          <div className={classes.body} ref={node => this._scroll = node}>
            {notes.map(note => {
              const { _id, body, date, author } = note;
              return (
                <div key={_id} className={classes.cellContainer}>
                  <div className={classes.cell}>
                    <div className={classes.textWrapper}>
                      <div className={classes.dateAuthor}>
                        <Typography color="textSecondary">
                          {date}
                        </Typography>
                        <Typography color="textSecondary">
                          by {author}
                        </Typography>
                      </div>
                      <Typography>{body}</Typography>
                    </div>
                    <IconButton onClick={this._onOpenMenu(note)}><MoreHoriz /></IconButton>
                  </div>
                  <Divider />
                </div>
              );
            })}
          </div>
          <Divider />
          <div className={classes.footer}>
            <Input
              placeholder={texts.notes.placeholder}
              fullWidth
              onChange={this._onChangeText}
              value={text}
            />
            <div className={classes.buttonContainer}>
              <Button
                color="primary"
                variant="raised"
                className={classes.button}
                onClick={this._onAddNote}
              >
                <NoteAdd className={classes.icon} />
                {texts.notes.button_text}
              </Button>
            </div>
          </div>
          <Menu
            id="note-options"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this._onCloseMenu}
          >
            <MenuItem onClick={this._onClickRemove}>{texts.notes.remove}</MenuItem>
          </Menu>
        </Card>
      </Modal>
    );
  }
}

Notes.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};


const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'Notes' }),
  connect(mapStateToProps, {})
)(Notes);



// WEBPACK FOOTER //
// ./src/app/components/user/Notes/index.js